<template>
  <div class="club-trainers">
    <div class="sport-tabs">
      <button
        v-for="(el, idx) in sports"
        :key="el.id"
        @click="sportSw(idx, el.id)"
      >
        <img :src="activeIcon(idx, el.id)" :alt="`sport${el.id}`" />
        <span class="title">{{ el.value }}</span>
      </button>
    </div>
    <div v-if="trainers.length" class="trainers-list">
      <TrainerCardItem v-for="el in filteredTrainers" :key="el.id" :tr="el" />
    </div>
    <div v-else class="no-trainers-msg">
      <p>{{ $t('common.no_trainers_in_club') }}</p>
    </div>
  </div>
</template>

<script>
import TrainerCardItem from '@/components/Club/parts/TrainerCardItem'
export default {
  name: 'Trainers',
  components: {
    TrainerCardItem
  },
  props: {
    club: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    tab: 'all',
    filtered: null
  }),
  computed: {
    sports() {
      return this.club?.club?.sports
    },
    trainers() {
      return this.club?.trainers
    },
    filteredTrainers() {
      return this.tab === 'all' ? this.trainers : this.filtered
    }
  },
  methods: {
    activeIcon(_idx, _id) {
      try {
        return require(`~/assets/img/sports/${
          this.tab === _idx ? 'orange' : 'gray'
        }/${_id}.png`)
      } catch (e) {
        return require(`~/assets/img/sports/gray/null.png`)
      }
    },
    sportSw(_idx, _id) {
      this.tab = _idx
      this.filtered = this.trainersFilter(_id)
    },
    trainersFilter(_id) {
      return this.trainers.filter((el) => {
        const { sportsWithOutdoors: sports } = el
        const ids = sports.map((s) => s.id)
        return el ? ids.includes(_id) : false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.club-trainers {
  .sport-tabs {
    padding: 10px;
    background-color: #f3f3f3;
    display: flex;
    flex-wrap: wrap;

    button {
      width: 25%;

      .title {
        display: none;
      }
    }
  }

  .no-trainers-msg {
    text-align: center;
    margin-top: -20px;

    p {
      min-height: 40px;
      line-height: normal;
      font-size: 16px;
      padding: 10px;
      border-radius: 3px;
      border: solid 1px #f0f0f0;
      background-color: $gray-lighter;
      color: #474747;
    }
  }
}

@media (min-width: 768px) {
  .club-trainers {
    .sport-tabs {
      padding: 0;
      background-color: transparent;
      justify-content: center;

      button {
        width: 15%;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          margin-bottom: 5px;
        }

        .title {
          font-size: 13px;
          color: #909090;
          display: block;
        }
      }
    }

    .trainers-list {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .no-trainers-msg {
      margin-top: 0;
    }
  }
}
</style>
